import { ReactComponent as LogoutBtn } from "assets/img/icons/logoutBtn.svg";
import { FC } from "react";
import { useAuth } from "app/hooks";
import { setUserManuallyDisconnected } from "app/hooks/useConnect";
import HeaderConnect from "app/widgets/crypto-header/header-connect";
import { useAccount, useDisconnect } from "wagmi";
import tokenService from "services/token.service";
import Button from "../button/button";
import ThemeSwitcher from "../theme-switcher/theme-switcher";

import { shortAddress } from "app/utils/shortAddress";
import styles from "./dashboard-header.module.scss";

const DashboardHeader: FC = () => {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();
  const isAuth = useAuth();

  const handleDisconnect = () => {
    setUserManuallyDisconnected(true);
    tokenService.removeToken();
    localStorage.removeItem("signature");
    disconnect();
    window.claimr?.logout();
  };

  return (
    <header className={styles.header}>
      <div className={styles.user}>
        {isAuth && address && (
          <>
            <Button variant="pink" className={styles.address}>
              {" "}
              {shortAddress(address)}
            </Button>
            <Button
              variant="pink"
              className={styles.logoutBtn}
              onClick={handleDisconnect}
            >
              <LogoutBtn />
            </Button>
          </>
        )}
        {!isAuth && (
          <div className={styles.connect}>
            <HeaderConnect />
          </div>
        )}
        <ThemeSwitcher />
      </div>
    </header>
  );
};

export default DashboardHeader;
